// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import Int64LookupResourceViewModel from '../../../../viewModel/resource/Int64LookupResourceViewModel';
import ResourceTypeNullableViewModel from '../../../../viewModel/resource/ResourceTypeNullableViewModel';
import ClassListResourceViewModel from '../../../../viewModel/resource/ClassListResourceViewModel';
import ClassListResourceDTO from '../../dto/resource/ClassListResourceDTO';

export default abstract class ClassListResourceModel extends BaseModel<ClassListResourceDTO> {
  /**
  * @type {int64}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  */
  get caption() { return this.dto.caption; }
  set caption(value) { this.dto.caption = value; }
  /**
  */
  get details() { return this.dto.details; }
  set details(value) { this.dto.details = value; }
  /**
  */
  get group() { return this.getObjectModel(() => this.dto.group, Int64LookupResourceViewModel)!; }
  set group(value) { this.setObjectModel(() => this.dto.group, value); }
  /**
  * @type {int32}
  */
  get sortOrder() { return this.dto.sortOrder; }
  set sortOrder(value) { this.dto.sortOrder = value; }
  /**
  */
  get courseType() { return this.getObjectModel(() => this.dto.courseType, Int64LookupResourceViewModel)!; }
  set courseType(value) { this.setObjectModel(() => this.dto.courseType, value); }
  /**
  * @type {date-time}
  */
  get startDate() { return this.dto.startDate; }
  set startDate(value) { this.dto.startDate = value; }
  /**
  * @type {date-time}
  */
  get endDate() { return this.dto.endDate; }
  set endDate(value) { this.dto.endDate = value; }
  /**
  */
  get leadReferentName() { return this.dto.leadReferentName; }
  set leadReferentName(value) { this.dto.leadReferentName = value; }
  /**
  */
  get city() { return this.dto.city; }
  set city(value) { this.dto.city = value; }
  /**
  */
  get status() { return this.getObjectModel(() => this.dto.status, Int64LookupResourceViewModel)!; }
  set status(value) { this.setObjectModel(() => this.dto.status, value); }
  /**
  * @type {int32}
  */
  get schedulerResourceType() { return this.dto.schedulerResourceType; }
  set schedulerResourceType(value) { this.dto.schedulerResourceType = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.id);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.id = value;
    this.dto.caption = qs.caption;
    value = Number.parseFloat(qs.sortorder);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.sortOrder = value;
    this.dto.startDate = qs.startdate;
    this.dto.endDate = qs.enddate;
    this.dto.leadReferentName = qs.leadreferentname;
    this.dto.city = qs.city;
    value = Number.parseFloat(qs.schedulerresourcetype);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.schedulerResourceType = value;
  }
}
